import React, {useState} from 'react';
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  Image,
  Platform,
} from 'react-native';
import {TEST_API} from '../../../utils/apiUrl';
import FormTextLabel from '../../../commonComponents/FormTextLabel';
import {Color, globalFontStyle} from '../../../assets';
import {Button} from '../../../components/core/Button';
import {isMobile, trackMoengageEvent} from '../../../utils/commonMethods';
import {useDispatch} from 'react-redux';
import {getConversionData} from '../redux/wallet.action';
import {globalConfigurableData} from '../../../utils/globalConstant';
import {globalImport} from '../../../common/globalImports';
import AsyncStorage from '@react-native-async-storage/async-storage';
import {globalConst} from '../../../utils/globalConstant';

const PaymentSelection = ({pG, onClick, setPaymentGateway, isWithdraw}) => {
  const dispatch = useDispatch();
  const [selected, setSelected] = useState(pG?.length > 0 ? pG[0] : null);

  const onProceed = async item => {
    if (globalImport.isWeb) {
      window.sessionStorage.setItem('pg', JSON.stringify(item));
      window.localStorage.setItem('pg', JSON.stringify(item));
    } else {
      await AsyncStorage.setItem('pg', JSON.stringify(item));
    }
    //dispatch(getConversionData({currency: item?.currency}));
    if (isMobile() || !isWithdraw) {
      onClick();
    } else {
      setSelected(item);
    }
    setPaymentGateway(item);
  };

  return (
    <>
      {isMobile() || !isWithdraw ? (
        <View style={{marginTop: 4, paddingBottom: 20, paddingHorizontal: 16}}>
          <FormTextLabel
            labelStyles={{
              ...globalFontStyle.appFontHeading,
              color: globalConfigurableData.primaryTextColor1,
              paddingTop: 4,
            }}
            label={isWithdraw ? 'Select Withdraw Type' : 'Select Deposit Type'}
          />
          {pG && (
            <View style={{marginTop: 15}}>
              {pG.map((item, i) => {
                return (
                  <TouchableOpacity
                    onPress={() => {
                      setSelected(item);
                    }}
                    key={i}
                    style={styles.selectionBox}>
                    <Image
                      style={{
                        width: 20,
                        height: 20,
                        marginRight: 10,
                      }}
                      source={{
                        uri: TEST_API + item?.icon,
                      }}
                    />
                    <Text
                      style={{
                        ...globalFontStyle.appFontSubTextBold,
                        color: globalConfigurableData.primaryTextColor1,
                        flex: 1,
                        paddingVertical: 10,
                      }}>
                      {item?.label}
                    </Text>
                    <View
                      style={{
                        borderRadius: 100,
                        borderWidth: 0.75,
                        borderColor: globalConfigurableData.borderColor,
                        padding: 5,
                      }}>
                      <View
                        style={{
                          borderRadius: 100,
                          backgroundColor:
                            item?.value === selected?.value
                              ? globalConfigurableData.primaryTextColor1
                              : globalConfigurableData.cardBgColor,
                          width: 10,
                          height: 10,
                        }}
                      />
                    </View>
                  </TouchableOpacity>
                );
              })}
              <Button
                variant="primary"
                onPress={() => {
                  setTimeout(() => {
                    onProceed(selected);
                  }, globalConst?.buttonTimer);
                }}
                translate={true}
              >
                Confirm Request
              </Button>
            </View>
          )}
        </View>
      ) : (
        <View style={{}}>
          {pG && (
            <View
              style={{
                marginBottom: 15,
                backgroundColor: '#EEEEEE',
                flexDirection: 'row',
                padding: 4,
                borderWidth: 0.75,
                borderRadius: 100,
                borderColor: globalConfigurableData.borderColor,
              }}>
              {pG.map((item, i) => {
                return (
                  <TouchableOpacity
                    onPress={() => {
                      onProceed(item);
                    }}
                    key={i}
                    style={
                      item?.value === selected?.value
                        ? styles.selectionBoxDesktop
                        : styles.unSelectedBoxDesktop
                    }>
                    <Image
                      style={{
                        width: 16,
                        height: 16,
                        marginRight: 10,
                      }}
                      source={{
                        uri:
                          item?.value === selected?.value
                            ? TEST_API + item?.selectedIcon
                            : TEST_API + item?.icon,
                      }}
                    />
                    <Text
                      style={{
                        ...globalFontStyle.appFontSubText,
                        color:
                          item?.value === selected?.value
                            ? globalConfigurableData.alternateTextColor
                            : globalConfigurableData.primaryTextColor1,
                        flex: 1,
                        paddingVertical: 8,
                      }}>
                      {item?.label}
                    </Text>
                  </TouchableOpacity>
                );
              })}
            </View>
          )}
        </View>
      )}
    </>
  );
};

export default PaymentSelection;

const styles = StyleSheet.create({
  selectionBox: {
    flexDirection: 'row',
    borderRadius: 5,
    alignItems: 'center',
    borderColor: globalConfigurableData.borderColor,
    borderWidth: 0.75,
    paddingHorizontal: 15,
    paddingVertical: 5,
    marginBottom: 15,
  },
  selectionBoxDesktop: {
    flexDirection: 'row',
    borderRadius: 100,
    flex: 1,
    alignItems: 'center',
    borderColor: globalConfigurableData.borderColor,
    borderWidth: 0.75,
    paddingHorizontal: 15,
    paddingVertical: 0,
    backgroundColor: globalConfigurableData.primaryTextColor1,
  },
  unSelectedBoxDesktop: {
    flexDirection: 'row',
    borderRadius: 100,
    flex: 1,
    alignItems: 'center',
    paddingHorizontal: 15,
    paddingVertical: 0,
  },
  appMobValKey: {
    color: globalConfigurableData.primaryTextColor1,
    ...globalFontStyle.appFontSubText,
  },
});
